import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import { Utils } from "arv-reactcomponents";

import Analytics from "../../../../../analytics";
import Event from "../../../../../analytics/eventFactory";

import NavTree from "../../NavTree";
import { generateGaLabel } from "../../../../../utils";

class MainNav extends Component {
  static trackShowNavTree(eventAction) {
    Analytics.trackEvent({
      action: eventAction,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_MENU_NAVIGATION,
    });
  }

  static trackNavClick(name) {
    MainNav.trackShowNavTree(`${generateGaLabel(name).toLowerCase()}_click`);
  }

  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };

    this.showNavTree = this.showNavTree.bind(this);
  }

  get isHighlightedClassName() {
    const { menu: { name } } = this.props;
    const nameLower = (name && name.toLowerCase()) || null;

    return (
      ((nameLower === "offers" || nameLower === "sale") && "is-highlighted") ||
      ""
    );
  }

  get isActiveClassName() {
    return (this.state.isActive && "is-active") || "";
  }

  showNavTree(bool, menuName) {
    return () => {
      if (bool) {
        const eventAction = `${generateGaLabel(menuName)}_hover`;
        MainNav.trackShowNavTree(eventAction);
      }

      this.setState({
        isActive: bool,
      });
    };
  }

  render() {
    const { menu } = this.props;
    const { isActive } = this.state;

    return (
      <li
        key={menu.name}
        className="nw-navcontainer-items"
        onMouseEnter={this.showNavTree(true, menu.name)}
        onFocus={Utils.noop}
        onMouseLeave={this.showNavTree(false)}
        onBlur={Utils.noop}
      >
        <a
          href={menu.url}
          onClick={() => {
            MainNav.trackNavClick(menu.name);
          }}
          className={`nw-navcontainer-link ${this.isActiveClassName} ${
            this.isHighlightedClassName
          }`}
        >
          {menu.name}
        </a>
        {document.querySelectorAll(".nw-navtree-holder")[0]
          ? ReactDOM.createPortal(
              <NavTree
                level={2}
                list={menu.level2}
                active={isActive}
                mainNav={menu.name}
                viewAllUrl={menu.url}
              />,
              document.querySelectorAll(".nw-navtree-holder")[0],
            )
          : null}
      </li>
    );
  }
}

MainNav.propTypes = {
  menu: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

export default MainNav;



// WEBPACK FOOTER //
// ./src/component/Header/DesktopHeader/NavContainer/MainNav/index.js